import React, { Component } from 'react'

export default class notFound extends Component {
    render() {
        return (
            <div>
                <h2>Page Not Found - 404</h2>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/page404.js